module.exports = __webpack_public_path__ + "static/media/09_tn.1f7e8d71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/09_tn.jpg
// module id = 318
// module chunks = 0